import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {Subscription} from 'rxjs';
import {MatDialog} from '@angular/material/dialog';
import {AdService} from '@services/ad.service';
import {LeadCommentComponent} from '@module/favorites/leads/lead-comment/lead-comment.component';
import {AlertService} from '@services/alert.service';
import {Favorite, PublisherLead} from '@models/favorite';
import {EMPTY_FAVORITE} from '@models/empty';

// Onglet « Leads » d'un favori publié : GET app/leads?favorite_id=… (filtre côté API)
@Component({
    selector: 'app-leads',
    templateUrl: './leads.component.html',
    styleUrls: ['./leads.component.scss']
})
export class LeadsComponent implements OnInit, OnDestroy {

    favorite: Favorite = Object.assign({}, EMPTY_FAVORITE);
    leads: PublisherLead[] = [];
    displayedColumns: string[] = ['created_at', 'name', 'email', 'mobile', 'status', 'comment'];
    dataSource = new MatTableDataSource<PublisherLead>([]);

    // Table derrière *ngIf : tri connecté via setter
    @ViewChild(MatSort) set matSort(sort: MatSort) {
        if (sort) {
            this.dataSource.sort = sort;
        }
    }
    statuses: string[] = [];
    loading = true;
    status = ''; // filtre statut ('' = tous)

    setStatus(status: string) {
        if (this.status === status) {
            return;
        }
        this.status = status;
        this.load();
    }
    private loadedFor = '';
    private sub: Subscription;

    constructor(private dialog: MatDialog, private adService: AdService, private alertService: AlertService) {
    }

    ngOnInit() {
        this.dataSource.sortingDataAccessor = (lead, column) => (this.constructor as any).sortAccessor(lead, column);
        this.sub = this.adService.getCacheFavorite().subscribe(favorite => {
            this.favorite = favorite;
            if (favorite.id && favorite.id !== this.loadedFor) {
                this.loadedFor = favorite.id;
                this.load();
            }
        });
    }

    ngOnDestroy() {
        if (this.sub) {
            this.sub.unsubscribe();
        }
    }

    load() {
        this.loading = true;
        this.adService.getLeads(this.favorite.id, this.status).subscribe(res => {
            this.leads = res.leads || [];
            this.dataSource.data = this.leads;
            if (res.statuses && res.statuses.length) {
                this.statuses = res.statuses;
            }
            this.loading = false;
        }, error => {
            this.loading = false;
            if (error != 'token_outdate') {
                this.alertService.error('Impossible de charger les leads de ce projet.');
            }
        });
    }

    openComment(lead: PublisherLead) {
        const dialogRef = this.dialog.open(LeadCommentComponent, {
            width: '480px',
            data: {lead},
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result !== false && result !== undefined) {
                lead.comment = result;
            }
        });
    }

    // Tri sur les champs imbriqués (intéressé, annonce)
    private static sortAccessor(lead: PublisherLead, column: string): string | number {
        switch (column) {
            case 'name':
                return lead.user ? ((lead.user.lastname || '') + ' ' + (lead.user.firstname || '')).toLowerCase() : '';
            case 'email':
                return lead.user ? (lead.user.email || '').toLowerCase() : '';
            case 'mobile':
                return lead.user ? (lead.user.mobile || '') : '';
            case 'ad':
                return lead.ad ? (lead.ad.title || '').toLowerCase() : '';
            case 'city':
                return lead.ad ? (lead.ad.city_name || '').toLowerCase() : '';
            case 'price':
                return lead.ad ? lead.ad.price : 0;
            default:
                return lead[column];
        }
    }
}
